/* Zabi Reviews — "Zie het zelf" video's.
   Echte <video>-elementen (poster + preload=none). Klik play-knop of kaart:
   overlay verbergen + video.play() met geluid. Eén video tegelijk (pauzeer andere).
   Geen externe libraries. */
(function () {
  function initSection(root) {
    var videos = root.querySelectorAll('[data-rv-video]');
    if (!videos.length) return;

    function playCard(card) {
      var v = card.querySelector('[data-rv-video]');
      if (!v) return;
      videos.forEach(function (o) {
        if (o !== v) {
          o.pause();
          var c = o.closest('.zabi-rv-vcard');
          if (c) c.classList.remove('zabi-rv-vcard--playing');
        }
      });
      card.classList.add('zabi-rv-vcard--playing');
      v.muted = false;
      v.setAttribute('controls', '');
      var p = v.play();
      if (p && p.catch) {
        p.catch(function () { v.muted = true; v.play(); });
      }
    }

    videos.forEach(function (v) {
      v.addEventListener('play', function () {
        var card = v.closest('.zabi-rv-vcard');
        if (card) card.classList.add('zabi-rv-vcard--playing');
        videos.forEach(function (o) {
          if (o !== v) {
            o.pause();
            var c = o.closest('.zabi-rv-vcard');
            if (c) c.classList.remove('zabi-rv-vcard--playing');
          }
        });
      });
    });

    root.querySelectorAll('[data-rv-play]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var card = btn.closest('.zabi-rv-vcard');
        if (card) playCard(card);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-rv-videos]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-rv-videos]');
    if (root) initSection(root);
  });
})();
